<template>
  <div class="phone-input">
    <div class="title">{{ title }}</div>
    <div class="input">
      <input
        :value="value"
        type="password"
        @keyup="inputPhone"
        :placeholder="placeholder"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "SetPassword",
  props: {
    value: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "设置密码"
    },
    placeholder: {
      type: String,
      default: "请输入密码"
    }
  },
  data: function() {
    return {};
  },
  methods: {
    inputPhone(e) {
      this.$emit("input", e.target.value);
    }
  }
};
</script>
<style lang="scss" scoped>
.phone-input {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #dcdcdc;
  display: flex;
  align-items: center;
  .title {
    width: 86px;
    text-align: left;
    line-height: 18px;
    font-size: 18px;
    height: 18px;
    flex-shrink: 0;
    border-right: 1px solid #969fa9;
  }
  .input {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 16px;
    input {
      font-size: 18px;
    }
  }
}
</style>
